import { RefreshCw, ShieldCheck, Lock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { PageHeader, NeonButton, Panel } from "../components/common";
import { GuardConsole } from "../components/guard/GuardConsole";
import { Findings, Events, Blocks } from "../components/guard/Findings";
import { useGuard } from "../components/guard/GuardContext";
import { LEVEL_COLOR } from "../components/guard/GuardOrb3D";

export const SecurityBody = () => {
  const { st, reload } = useGuard();
  const { isOwner } = useAuth();
  if (!st) return <p className="font-mono text-xs text-white/40">connecting to Guard…</p>;
  const color = LEVEL_COLOR[st.level];
  return (
    <div className="space-y-6" data-testid="security-body">
      <div className="grid md:grid-cols-4 gap-4">
        {[["Threat level", st.level.toUpperCase(), color], ["Findings", st.findings.length], ["High severity", st.high, st.high ? "#FF003C" : undefined], ["Events · 24h", st.events.length]].map(([k, v, c]) => (
          <div key={k} className="panel p-4" data-testid={`security-kpi-${k.toLowerCase().replace(/[^a-z]/g, "")}`}><p className="label-xs">{k}</p><p className="font-mono text-2xl font-extrabold mt-1" style={{ color: c || "#fff" }}>{v}</p></div>
        ))}
      </div>
      <Panel title="Ask Guard · voice or text" testid="security-console-panel"><GuardConsole level={st.level} session="security" big testid="security-console" /></Panel>
      <div className="grid lg:grid-cols-2 gap-6">
        <Panel title={`Fraud & threat findings (${st.findings.length})`} testid="security-findings-panel"><div className="max-h-[520px] overflow-y-auto"><Findings items={st.findings} reload={reload} canAct={isOwner} admin={st.admin} /></div></Panel>
        <div className="space-y-6">
          <Panel title="Live security events · 24h" testid="security-events-panel"><div className="max-h-72 overflow-y-auto"><Events items={st.events} /></div></Panel>
          <Panel title="How Guard protects you" testid="security-policy-panel">
            <p className="label-xs mb-2 flex items-center gap-2"><ShieldCheck className="w-3 h-3" /> Automatic</p>
            <ul className="text-sm text-white/70 space-y-1 mb-4">{st.auto.map((a) => <li key={a}>· {a}</li>)}</ul>
            <p className="label-xs mb-2 flex items-center gap-2"><Lock className="w-3 h-3" /> Needs your one-click approval</p>
            <ul className="text-sm text-white/70 space-y-1">{st.approval.map((a) => <li key={a}>· {a}</li>)}</ul>
            <p className="text-xs text-white/40 mt-4">Guard protects this platform and its data. It can't scan your own computer, so keep antivirus on your devices. Guard never refunds money.</p>
          </Panel>
          {st.admin && <Panel title="Blocked network addresses" testid="security-blocks-panel"><Blocks items={st.blocks} reload={reload} /></Panel>}
        </div>
      </div>
    </div>
  );
};

export default function Security() {
  const { reload } = useGuard();
  return (
    <div data-testid="security-page">
      <PageHeader eyebrow="// ai security officer" title="AEGIS Guard"><NeonButton variant="ghost" onClick={reload} data-testid="security-refresh"><RefreshCw className="w-3 h-3" /> Refresh</NeonButton></PageHeader>
      <SecurityBody />
    </div>
  );
}
